<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A1wcNA/tc-custom/9781617455414.jpg?1694750726826" alt="This image is the cover for the book Art of Mixing Textiles in Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Art of Mixing Textiles in Quilts
      </h1>
      <p class="bookDescription body article font2">
        <b>Bring a new level of richness and variety to your quilts with this guide to mixed-fabric quilting.</b><br/><br/>It’s time to go beyond cottons. With <i>The Art of Mixing Textiles</i>, you will learn how to blend your standard quilting fabrics with rich wools, lustrous silks, and textural home decor fabrics for quilts that beg to be touched. Quilt designer Lynn Schmitt teaches you the secrets to cutting, piecing, sewing, and pressing fabrics of texture and sheen. <br/><br/>The step-by-step instructions in this volume make it easy to get started. The 14 pieced and appliquéd projects include table runners, quilts, pincushions, tote bags, and more. Dimensional and exciting, mixed-fabric quilts are ripe for using up scraps and expanding your horizons!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynn Schmitt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bbc5a92